import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SummarySectionTitle from './Component/SummarySectionTitle';
import SummaryFeaturePrinting from './Component/SummaryFeaturePrinting';
import { currencyFormatter } from '../../utils/currencyFormatter';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import { PriceUtility } from '../../utilities/PriceUtility';
import IsNullOrUndefined from '../../utils/ObjectUtils';

const SummarySectionsListPrinting = ({ includesPrices }) => {
  const {
 categories, sections, totalPrice, vat,
} = useSelector(state => state.configurator);

  const getSummarySection = (section, category, countCategory) => (
    <div className="container-title-feature">
      {countCategory === 0 ? (
        <SummarySectionTitle
          section={section}
          includesPrices={
            includesPrices && vat.public_prices_total_price_enabled
          }
        />
      ) : null}
      <SummaryFeaturePrinting
        categoryName={TranslationUtility.GetFormattedMessageForCategoryName(
          category,
        )}
        feature={category.features.find(
          feature => feature.id === category.selected_feature,
        )}
        disabled={category.disabled}
        includesPrices={includesPrices}
      />
    </div>
  );
  return (
    <div className="summary-sections-list-printing">
      <div className="summary-sections-list-header">
        <div className="title">{TranslationUtility.GetFormattedMessageForUI('ui-summary-panel-title',
              'Su configuración')}
        </div>
      </div>

      <div className="description">
        {TranslationUtility.GetFormattedMessageForUI('ui-printing-budget-selected-options-title',
              'A continuación se muestra un resumen de las opciones que ha seleccionado:')}
      </div>
      <div className="container-sections">
        {sections !== undefined && sections.map((section, index) => (
          <>
            <div className="summary-feature-container">
              {
                              section.categories.map((category, index2) => {
                                  if (category.features !== undefined && category.features.length > 0) {
                                      return getSummarySection(section, category, index2);
                                  }
                                  return null;
                              })
                          }
            </div>
          </>
              ))}
      </div>
      {(includesPrices && vat.public_prices_enabled !== false && vat.public_prices_total_price_enabled !== false) ? (
        <div className="total-price-summary-container">
          <div className="divider" />
          {!IsNullOrUndefined(vat) && !vat.vat_breakdown_disabled
            ? (
              <div className="total-price-exc-vat-row">
                <div className="title">
                  {TranslationUtility.GetFormattedMessageForUI('ui-summary-total-price-excl-vat',
                                'TOTAL OPCIONES (sin IVA)')}
                </div>
                <div className="value">{currencyFormatter.format(totalPrice)}</div>
              </div>
          ) : null}
          {!IsNullOrUndefined(vat) && vat.vat_enabled && !vat.vat_breakdown_disabled
                ? (
                  <div className="vat-row">
                    <div className="title">
                      {TranslationUtility.GetFormattedMessageForUI('ui-summary-vat',
                              'IVA')}
                    </div>
                    <div className="value">
                      {currencyFormatter.format(PriceUtility.calculateVatValue(categories, vat))}
                    </div>
                  </div>
          ) : null}
          {!IsNullOrUndefined(vat) && vat.vat_enabled
              ? (
                <div className="total-price-inc-vat-row">
                  <div className="title">
                    {TranslationUtility.GetFormattedMessageForUI('ui-summary-total-price-incl-vat',
                              'PRECIO TOTAL OPCIONES (con IVA)')}
                  </div>
                  <div className="value">
                    {currencyFormatter.format(PriceUtility.calculateTotalPriceIncVat(categories, vat))}
                  </div>
                </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

SummarySectionsListPrinting.propTypes = {
    includesPrices: PropTypes.bool.isRequired,
};

export default SummarySectionsListPrinting;
